export const invoiceSettingsFormName = 'invoice-settings-form';
